/* global angular */

angular.module('emptyDashFormatterCmp', [])
  .filter('emptyDash', function () {
    return function (input) {
      if (!input || input === 0 || angular.isUndefined(input)) {
        return '-'
      } else {
        return input
      }
    }
  })
